import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/login'
	},

  {
    path: '/login',
    name: 'Home',
    component: Home
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue')
  },
  {
    path: '/forgetPassWord',
    name: 'ForgetPassWord',
    component: () => import(/* webpackChunkName: "forgetPassWord" */ '../views/forgetPassWord.vue')
  },
  {
    path: '/chooseStyle',
    name: 'chooseStyle',
    component: () => import(/* webpackChunkName: "chooseStyle" */ '../views/chooseStyle.vue')
  },
  
  {
    path: '/home',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
